module.exports = __webpack_public_path__ + "images/tour/lesson_plan_by_day_record_lesson-609d9dee0d4862efef795cffa870b02a.gif";